
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TCaseHighlight } from "@/models/case_highlight";
import copy from "copy-to-clipboard";
import { SMToaster, SMUser, SMCases } from "@/store";
import {
  DEPENDANT_INSIDE_SERVICE_TYPE,
  ELIGIBILITY_CHECK_SERVICE_TYPE,
  SW_SERVICES_TYPES,
} from "@/constants/services";
import { API_TCase } from "@/models/cases";

@Component
export default class Highlight extends Vue {
  highlights: API_TCaseHighlight[] = [];

  init = false;

  get showMenu() {
    return this.showDependantsList || this.showParentService || this.showECAndSWVMenu;
  }

  get isECWithSWVStarted() {
    const { case_template, child_case_id } = SMCases.case as API_TCase;

    const { name_dev } = case_template;

    return [ELIGIBILITY_CHECK_SERVICE_TYPE].includes(name_dev) && child_case_id;
  }

  get ECService() {
    if (!this.isSWVWithEC) return null;

    const id = ((SMCases.case as unknown) as any).parent_case_id;

    return {
      case_id: id,
      name: this.$t("labels.parentServiceWithId", { id }),
    };
  }

  get isSWVWithEC() {
    const { case_template, parent_case_id } = SMCases.case as API_TCase;

    const { case_type } = case_template;

    return [...SW_SERVICES_TYPES].includes(case_type) && parent_case_id;
  }

  get SWVService() {
    if (!this.isECWithSWVStarted) return null;

    const id = ((SMCases.case as unknown) as any).child_case_id;

    return {
      case_id: id,
      name: this.$t("labels.parentServiceWithId", { id }),
    };
  }

  get showECAndSWVMenu() {
    return this.isECWithSWVStarted || this.isSWVWithEC;
  }

  get dependants() {
    const dependants = ((SMCases.case as unknown) as any)?.dependants ?? [];

    return dependants.reduce((acc, cur) => {
      const { id, first_name, last_name, case_id } = cur;

      acc.push({
        id,
        case_id,
        fullName: `${first_name} ${last_name}`,
      });

      return acc;
    }, []);
  }

  get showDependantsList() {
    return this.dependants.length && !this.parentService;
  }

  get isDependantCase() {
    const dependantCaseTypes = [DEPENDANT_INSIDE_SERVICE_TYPE];

    return dependantCaseTypes.includes(SMCases.caseType);
  }

  get parentService() {
    if (!this.isDependantCase) return null;

    const id = ((SMCases.case as unknown) as any).parent_case_id;

    return {
      case_id: id,
      name: this.$t("labels.parentServiceWithId", { id }),
    };
  }

  get showParentService() {
    return !!this.parentService;
  }

  goToCase(item) {
    const { case_id } = item;

    if (!case_id) return;

    const routeData = this.$router.resolve(`/cases/${case_id}`);

    window.open(routeData.href, "_blank");
  }

  goToCaseId(case_id) {
    if (!case_id) return;

    const routeData = this.$router.resolve(`/cases/${case_id}`);

    window.open(routeData.href, "_blank");
  }

  async mounted() {
    await this.fetchHighlights();
  }

  get caseId() {
    return Number(this.$route.params.id ?? 0);
  }

  async fetchHighlights() {
    if (!this.caseId) return;

    try {
      const { data } = await this.axios.get(API_ROUTES.CASE_HIGHLIGHTS(this.caseId));

      if (!data) return;

      this.highlights = data;
    } finally {
      this.init = true;
    }
  }

  onRightClick(result: string) {
    if (!result) return;

    if (!SMUser.isExpert) return;

    copy(result);

    SMToaster.emitSuccess({
      title: this.$root.$tc("notification.copied").toString(),
      message: result,
    });
  }

  get otherCases() {
    return SMCases.otherCases;
  }

  getCaseAbbr(caseType: string) {
    if (caseType === "Candidate Assessment") return "EC";

    return "SWV";
  }
}
